import { z } from 'zod'
import { optionalString, requiredString, timestampedDocSchema } from '../utils/basicSchemas/document.z.schema'
import { mongoId, mongoIdSchema } from '../utils/basicSchemas/_id.z.schema'
import { ZSchema } from '../utils/zodSchema'


const itemSchema = z.object({
    itemType: z.enum(["Individual item", "Collection"], {
        invalid_type_error: "Item type is invalid"
    }),
    itemCategory: requiredString("Item category"),
    individualItemThumbnail: requiredString("Item thumbnail"),
    itemTitle: z.string()
        .min(1, "item title must be at least one character")
        .max(30, "item title must be at most 30 characters")
        .regex(/^(?=.*[a-z])[ 0-9a-zA-Z]{1,30}$/i, "item title is invalid"),
    itemDescription: z.string()
        .min(1, "item description must be at least one character")
        .max(300, "item description must be at most 300 characters")
        .regex(/^.{1,300}$/, "item description is invalid"),

})
const itemUpdateSchema = z.object({
    updates: z.object({
        itemType: z.enum(["Individual item", "Collection"], {
            invalid_type_error: "Item type is invalid"
        }),
        // TODO: are these not optional ? 
        itemTags: z.array(z.any(),).min(1, "At least 1 tag is required"),
        // TODO: are these not optional ? 
        itemTagsToDelete: z.array(z.any()).min(1, "At least 1 tag to delete is required"),
        itemTitle: z.string()
            .min(1, "item title must be at least one character")
            .max(30, "item title must be at most 30 characters")
            .regex(/^(?=.*[a-z])[ 0-9a-zA-Z]{1,30}$/i, "item title is invalid")
            .optional(),
        itemDescription: z.string()
            .min(1, "item description must be at least one character")
            .max(300, "item description must be at most 300 characters")
            .regex(/^.{1,300}$/, "item description is invalid")
    }),
})

const itemIdSchema = z.object({
    id: mongoId("item id"),
})



const itemValidator = new ZSchema(
    { bodySchema: itemSchema })

const itemUpdateValidator = new ZSchema(
    { bodySchema: itemUpdateSchema, paramSchema: itemIdSchema })

// TODO: UNTESTED:
export { itemValidator, itemUpdateValidator }
